let baseURL = ''; // 接口请求地址
let DownloadUrl = '';//下载地址
let WebUrl = '';//官网地址
if (process.env.NODE_ENV == 'development') {
    baseURL = 'https://testadminapi.lg.qyzhrccs.com/api';
    DownloadUrl = 'https://testadminapi.lg.qyzhrccs.com/api';
    WebUrl = '';
} else {
    if ( process.env.NODE_ENV == 'production' ) { // 生产环境
        baseURL = 'https://adminapi.lg.qyzhrccs.com/api';
        DownloadUrl = 'https://adminapi.lg.qyzhrccs.com/api';
        WebUrl = '';
    } else { // 开发环境
        baseURL = 'https://testadminapi.lg.qyzhrccs.com/api';
        DownloadUrl = 'https://testadminapi.lg.qyzhrccs.com/api';
        WebUrl = '';
    }
}
export { baseURL, DownloadUrl,WebUrl }



// WEBPACK FOOTER //
// ./src/api/base.js